var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Login", {
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c("span", { attrs: { id: "loginTitle" } }, [
              _vm._v(_vm._s(_vm.$t("ForgotPassword")))
            ]),
            _vm._v(" "),
            _c("span", { attrs: { id: "loginMessage" } }, [
              _vm._v(_vm._s(_vm.$t("PasswordMessage")))
            ])
          ]
        },
        proxy: true
      },
      {
        key: "form",
        fn: function() {
          return [
            _c(
              "form",
              {
                staticClass: "loginForm",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "main-login-form-container" }, [
                  _c("div", { staticClass: "email-div" }, [
                    _c("span", { staticClass: "login-input-label" }, [
                      _vm._v(_vm._s(_vm.$t("Email")))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      ref: "email",
                      staticClass: "loginInput userInput effect-7",
                      attrs: {
                        type: "email",
                        name: "email",
                        spellcheck: "false"
                      },
                      domProps: { value: _vm.email },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.recoverySubmit.apply(null, arguments)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "button",
        fn: function() {
          return [
            _c(
              "v-btn",
              {
                staticClass: "signInInput",
                attrs: {
                  type: "submit",
                  color: "accent--text",
                  outlined: "",
                  disabled: !_vm.email
                },
                on: { click: _vm.recoverySubmit }
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("Send")) + "\n    ")]
            )
          ]
        },
        proxy: true
      },
      {
        key: "remember-me-reset-password",
        fn: function() {
          return [
            _c("div", { staticClass: "field-success-div" }, [
              _vm.emailSent
                ? _c("span", { staticClass: "field-success-div-span" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("EmailSentSuccess")) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-701aeed4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-701aeed4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/LoginRecoveryEmail.vue
// module id = null
// module chunks = 